import { render, staticRenderFns } from "./MenuCell.vue?vue&type=template&id=a28ac880&scoped=true"
import script from "./MenuCell.vue?vue&type=script&lang=ts&setup=true"
export * from "./MenuCell.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a28ac880",
  null
  
)

export default component.exports